import type { PersistConfig } from '@ms/yammer-data/dist/persistedState';
import { getPersistConfig } from '@ms/yammer-data/dist/persistedState';

import type { YammerTeamsState } from '../state/types';

export const persistConfig: PersistConfig<YammerTeamsState> = getPersistConfig<YammerTeamsState>({
  key: 'teams',
  allowlist: ['ecsConfig', 'ecsExperiments', 'ecsFeatureRollouts'],
});
